import smartDate from "@qrohlf/smart-date";
import { ModalOverlay } from "common/styleguide/ModalOverlay";
import React from "react";
import styles from "./SingleMessageDialog.scss";

export const SINGLE_MESSAGE_DIALOG = "SINGLE_MESSAGE_DIALOG";

export class SingleMessageDialog extends React.PureComponent {
  render() {
    const { message, onRequestClose } = this.props;

    return (
      <ModalOverlay onRequestClose={onRequestClose} maxWidth="380px">
        <div className={styles.content}>{message.content}</div>
        <div className={styles.createdAt}>{smartDate(message.createdAt, { relative: "day" })}</div>
      </ModalOverlay>
    );
  }
}
